export default __webpack_public_path__ + "static/media/pfdintextpro-medium-webfont.e279c358.woff";